// Renders a server-side validation message for a field, read from Inertia's
// `errors` bag (useForm().errors). Renders nothing when there's no error.
export function FieldError({ message }: { message?: string }) {
  if (!message) return null
  return (
    <p role="alert" className="text-sm text-destructive">
      {message}
    </p>
  )
}
